


import useBaseApiHook, { BASE_API_CONSTANT } from "services/useBaseApiHook"

const REPO_URL = {
    getParamCategory: '/param/category',
    getById: '/param/id' 
}

const useParamRepo = (initialLoading = false) => {
    const { isLoading, data, error, executeApi } = useBaseApiHook(initialLoading)

    const getParamByCategory = async (payload) => {
        return await executeApi(REPO_URL.getParamCategory, BASE_API_CONSTANT.METHOD.POST, payload)
    }


    return {
        isLoading,
        data,
        error,
        getParamByCategory,
    }
}

export default useParamRepo
